import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Element from "element-ui";
import "@/utils/lib-flexible";
import "element-ui/lib/theme-chalk/index.css"; //样式表
// import '@/css/all.css'   //样式表
import enLang from "element-ui/lib/locale/lang/zh-CN"; // 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖
// register globally
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "en",
  messages: {
    zh: require("./components/language/zh"),
    en: require("./components/language/en"),
  },
});
import * as funct from "@/varfunction";
Vue.prototype.$funct = funct;
import ExportUtil from "../src/views/pages/js/ExportUtil";
Vue.prototype.ExportUtil = ExportUtil;
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import "@/svgIcon/index.js";
import setStorage from "@/utils/Storge"; /* 封装缓存 */
Vue.prototype.$Storage = setStorage;
/* import 'lib-flexible'//适配依赖 */
import "@/utils/lib-flexible";

// import '@/css/all.css'   //全局样式表
import md5 from "js-md5"; //md5加密
Vue.prototype.$md5 = md5;
import locale from "element-ui/lib/locale/lang/en";
Vue.use(Element, {
  size: "small", // set element-ui default size
  locale,
});
import Table from "@/components/Table/index";
Vue.component("Table", Table);
import Pagination from "@/components/Pagination/index";
Vue.component("Pagination", Pagination);
import Breadcrumb from "@/components/Breadcrumb/index";
Vue.component("Breadcrumb", Breadcrumb);
Vue.config.productionTip = false;

// },200)
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
